/**
 * Sauna Unit Product Template JavaScript
 * Handles vertical thumbnail slider and tab functionality
 */

(function() {
  'use strict';

  // Mobile Horizontal Thumbnail Slider (シンプルスクロール)
  class MobileThumbnailSlider {
    constructor(container) {
      this.container = container;

      this.track = container.querySelector('[data-slider-track]')
        || container.querySelector('.product-single__thumbnails-slider-track')
        || container.querySelector('.product-single__thumbnails')
        || container.querySelector('ul');

      this.items = Array.from(container.querySelectorAll('[data-slider-item]'));
      if (this.items.length === 0) {
        this.items = Array.from(container.querySelectorAll('.product-single__thumbnails-item'));
      }
      if (this.items.length === 0) {
        this.items = Array.from(container.querySelectorAll('li'));
      }

      this.prevBtn = container.querySelector('[data-slider-button]:not([data-slider-button-next])')
        || container.querySelector('.thumbnails-slider__prev')
        || container.querySelector('.slider-button--prev');
      this.nextBtn = container.querySelector('[data-slider-button-next]')
        || container.querySelector('.thumbnails-slider__next')
        || container.querySelector('.slider-button--next');

      this.scrollStep = 0;

      this.init();
    }

    init() {
      if (!this.track || this.items.length === 0) {
        return;
      }

      this.setupStyles();
      this.scrollStep = this.getScrollAmount();
      this.bindArrowButtons();

      window.addEventListener('resize', () => {
        this.scrollStep = this.getScrollAmount();
      });
    }

    setupStyles() {
      if (this.track) {
        this.track.style.display = 'flex';
        this.track.style.flexWrap = 'nowrap';
        this.track.style.overflowX = 'auto';
        this.track.style.scrollBehavior = 'smooth';
        this.track.style.scrollSnapType = 'x proximity';
      }

      this.items.forEach((item) => {
        item.style.flex = '0 0 auto';
        item.style.scrollSnapAlign = 'start';
      });
    }

    bindArrowButtons() {
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.scrollByStep(-1);
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.scrollByStep(1);
        });
      }
    }

    getScrollAmount() {
      if (!this.items.length) {
        return this.track && this.track.clientWidth ? this.track.clientWidth : 200;
      }

      const style = window.getComputedStyle(this.items[0]);
      const marginRight = parseFloat(style.marginRight) || 0;
      return this.items[0].offsetWidth + marginRight;
    }

    scrollByStep(direction) {
      if (!this.track || this.scrollStep === 0) return;

      this.track.scrollBy({
        left: direction * this.scrollStep,
        behavior: 'smooth'
      });
    }
  }

  // Vertical Thumbnail Slider (Minimal Version)
  class SaunaThumbnailSlider {
    constructor(container) {
      this.container = container;
      this.items = Array.from(container.querySelectorAll('.sauna-thumbnail-item'));
      
      this.init();
    }

    init() {
      if (this.items.length === 0) return;

      // Set initial active state
      if (this.items.length > 0) {
        this.items[0].classList.add('active');
      }

      // Click handlers for thumbnails
      this.items.forEach((item, index) => {
        item.addEventListener('click', () => this.selectThumbnail(index));
      });

      // 初期表示時のALTテキストを設定
      this.updateAltText();
    }

    selectThumbnail(index) {
      // Remove active class from all thumbnails
      this.items.forEach(item => item.classList.remove('active'));
      
      // Add active class to selected thumbnail
      this.items[index].classList.add('active');

      // Get media ID from thumbnail
      const mediaId = this.items[index].dataset.mediaId;
      
      // Trigger media change in main gallery
      this.changeMainMedia(mediaId);
    }

    changeMainMedia(mediaId) {
      // 横型サムネイルをトリガーして、元のテーマのメディア切り替えロジックを活用
      const horizontalThumbnail = document.querySelector(`[data-thumbnail-id="${mediaId}"]`);
      
      if (horizontalThumbnail) {
        // 横型サムネイルが存在する場合は、それをクリックして標準のメディア切り替えを実行
        horizontalThumbnail.click();
        
        // ALTテキストを明示的に更新
        setTimeout(() => {
          this.updateAltText();
        }, 100);
      } else {
        console.warn(`Thumbnail not found for media ID: ${mediaId}`);
      }
    }

    updateAltText() {
      // 表示中のラッパー（hide クラスがないもの）を取得
      const visibleWrapper = document.querySelector('.product-single__media-wrapper:not(.hide)');
      if (!visibleWrapper) return;

      // ラッパー内のALTテキストを取得
      const altText = visibleWrapper.querySelector('.alt-text-container');
      if (!altText) return;

      // すべてのALTテキストを一旦非表示
      document.querySelectorAll('.product-single__media-wrapper .alt-text-container').forEach(alt => {
        alt.style.display = 'none';
      });

      // 表示中のラッパーのALTテキストのみ表示
      altText.style.display = 'block';
    }

  }

  // Tab Functionality
  class SaunaTabs {
    constructor(container) {
      this.container = container;
      this.buttons = Array.from(container.querySelectorAll('.sauna-tab-button'));
      this.contents = Array.from(container.querySelectorAll('.sauna-tab-content'));
      this.isInitializing = true; // 初期化中フラグ（ページ読み込み時の自動スクロールを防ぐ）
      
      this.init();
    }

    init() {
      if (this.buttons.length === 0) return;

      // Set first tab as active by default
      this.activateTab(0);

      // Click handlers for tab buttons
      this.buttons.forEach((button, index) => {
        button.addEventListener('click', () => this.activateTab(index));
      });

      // キーボードナビゲーション対応
      this.buttons.forEach((button, index) => {
        button.addEventListener('keydown', (e) => this.handleKeydown(e, index));
      });

      // 概要タブ内のリンクに対するタブ切り替え機能を追加
      this.setupTabSwitchingLinks();

      // URL hashに基づいてタブを開く
      this.handleUrlHash();

      // 初期化完了（これ以降のタブクリック時はスクロールを有効にする）
      this.isInitializing = false;
    }

    activateTab(index) {
      // Deactivate all tabs
      this.buttons.forEach((btn, i) => {
        btn.classList.remove('active');
        btn.setAttribute('aria-selected', 'false');
        btn.setAttribute('tabindex', '-1');
      });

      this.contents.forEach((content) => {
        content.classList.remove('active');
        content.setAttribute('hidden', '');
      });

      // Activate selected tab
      if (this.buttons[index]) {
        this.buttons[index].classList.add('active');
        this.buttons[index].setAttribute('aria-selected', 'true');
        this.buttons[index].removeAttribute('tabindex');
      }

      if (this.contents[index]) {
        this.contents[index].classList.add('active');
        this.contents[index].removeAttribute('hidden');
      }

      // 3Dモデルのパフォーマンス最適化
      this.optimize3DModels(index);

      // GA4イベント送信（初期化時以外、かつgtagが定義されている場合のみ）
      if (!this.isInitializing && typeof gtag === 'function' && this.buttons[index]) {
        const tabName = this.buttons[index].dataset.tabName || this.buttons[index].textContent.trim();
        const tabId = this.buttons[index].dataset.tab;

        gtag('event', 'tab_click', {
          'tab_name': tabName,
          'tab_id': tabId,
          'page_type': 'product',
          'product_template': 'sauna-unit'
        });
      }

      // 初期化時以外（ユーザーのクリック時）のみスクロール
      if (!this.isInitializing) {
        this.scrollToActiveTab();
      }
    }

    handleKeydown(e, currentIndex) {
      let newIndex = currentIndex;
      
      // 左矢印キー: 前のタブへ
      if (e.key === 'ArrowLeft') {
        newIndex = currentIndex > 0 ? currentIndex - 1 : this.buttons.length - 1;
        e.preventDefault();
      }
      // 右矢印キー: 次のタブへ
      else if (e.key === 'ArrowRight') {
        newIndex = currentIndex < this.buttons.length - 1 ? currentIndex + 1 : 0;
        e.preventDefault();
      }
      // Homeキー: 最初のタブへ
      else if (e.key === 'Home') {
        newIndex = 0;
        e.preventDefault();
      }
      // Endキー: 最後のタブへ
      else if (e.key === 'End') {
        newIndex = this.buttons.length - 1;
        e.preventDefault();
      }
      
      if (newIndex !== currentIndex) {
        this.activateTab(newIndex);
        this.buttons[newIndex].focus();
      }
    }

    scrollToActiveTab() {
      const activeButton = this.container.querySelector('.sauna-tab-button.active');
      const nav = activeButton && activeButton.parentElement;
      if (nav && nav.scrollWidth <= nav.clientWidth) return; // 折り返して全部見えているときは動かさない
      if (activeButton && window.innerWidth < 750) {
        // Smooth scroll active button into view on mobile
        activeButton.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }
    }

    /**
     * 概要タブ内のリンクに対してタブ切り替え機能を設定
     */
    setupTabSwitchingLinks() {
      // 製品の仕様リンク (#p-detail1) → スペック・詳細タブへ
      const specLink = document.querySelector('.c-product_linklist a.info[href="#p-detail1"]');
      if (specLink) {
        specLink.addEventListener('click', (e) => {
          e.preventDefault();
          this.switchToTabByType('description', true); // タブ最上部へスクロール
        });
      }

      // 付属・設置・梱包について (#p-detail2) → スペック・詳細タブへ + スクロール
      const installLink = document.querySelector('.c-product_linklist a.info2[href="#p-detail2"]');
      if (installLink) {
        installLink.addEventListener('click', (e) => {
          e.preventDefault();
          this.switchToTabByType('description', false, '#p-detail2'); // 該当IDまでスクロール
        });
      }

      // 費用内訳・導入までの流れ (#cost-breakdown) → 導入までの流れタブへ
      const costLink = document.querySelector('.c-product_linklist a.case-study[href="#cost-breakdown"]');
      if (costLink) {
        costLink.addEventListener('click', (e) => {
          e.preventDefault();
          this.switchToTabByType('process', true); // タブ最上部へスクロール
        });
      }
    }

    /**
     * URL hashに基づいて適切なタブを開く
     */
    handleUrlHash() {
      const hash = window.location.hash;
      if (!hash) return;

      // hashに基づいてタブを切り替え
      if (hash === '#p-detail1') {
        this.switchToTabByType('description', true);
      } else if (hash === '#p-detail2') {
        this.switchToTabByType('description', false, hash);
      } else if (hash === '#cost-breakdown') {
        this.switchToTabByType('process', true);
      }
    }

    /**
     * タブタイプ(data-tab属性)に基づいてタブを切り替え
     * @param {string} tabType - タブのタイプ ('overview', 'description', 'comparison', 'process')
     * @param {boolean} scrollToTop - タブ最上部にスクロールするか
     * @param {string} targetId - スクロール先の要素ID（オプショナル）
     */
    switchToTabByType(tabType, scrollToTop = true, targetId = null) {
      // 指定されたタイプのタブを見つける
      const targetButton = this.buttons.find(btn => btn.dataset.tab === tabType);
      if (!targetButton) {
        console.warn(`Tab type "${tabType}" not found`);
        return;
      }

      // タブのインデックスを取得
      const tabIndex = this.buttons.indexOf(targetButton);
      
      // 初期化フラグを一時的にfalseに設定（スクロールを有効にする）
      const wasInitializing = this.isInitializing;
      this.isInitializing = false;

      // タブをアクティブ化
      this.activateTab(tabIndex);

      // スクロール処理
      setTimeout(() => {
        if (targetId) {
          // 特定のIDまでスクロール
          const targetElement = document.querySelector(targetId);
          if (targetElement) {
            const tabsNav = this.container.querySelector('.sauna-tabs-nav');
            let navBottom = 0;
            if (tabsNav) {
              navBottom = tabsNav.classList.contains('is-fixed')
                ? tabsNav.getBoundingClientRect().bottom
                : (window.innerWidth >= 750 ? 100 : 0) + tabsNav.offsetHeight;
            }
            const offset = Math.max(100, navBottom + 12); // ヘッダー・固定タブの高さを考慮したオフセット
            const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
            const offsetPosition = elementPosition - offset;

            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
          }
        } else if (scrollToTop) {
          // タブナビゲーションが最上部に来るようにスクロール
          const tabContainer = this.container.querySelector('.sauna-tabs-nav');
          if (tabContainer) {
            const offset = 20; // 少しの余白
            const elementPosition = tabContainer.getBoundingClientRect().top + window.pageYOffset;
            const offsetPosition = elementPosition - offset;

            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
          }
        }
      }, 100); // タブ切り替えのアニメーション後にスクロール

      // 初期化フラグを元に戻す
      this.isInitializing = wasInitializing;
    }

    /**
     * 3Dモデルのパフォーマンスを最適化
     * アクティブなタブの3Dモデル以外は無効化してパフォーマンスを改善
     * @param {number} activeIndex - アクティブなタブのインデックス
     */
    optimize3DModels(activeIndex) {
      this.contents.forEach((content, index) => {
        const modelViewers = content.querySelectorAll('model-viewer');

        modelViewers.forEach(viewer => {
          if (index === activeIndex) {
            // アクティブタブの3Dモデルを有効化
            viewer.style.display = '';
            if (!viewer.hasAttribute('camera-controls')) {
              viewer.setAttribute('camera-controls', '');
            }
            if (!viewer.hasAttribute('auto-rotate')) {
              viewer.setAttribute('auto-rotate', '');
            }
            // WebGLレンダリングを再開
            if (viewer.pause) {
              viewer.pause = false;
            }
          } else {
            // 非アクティブタブの3Dモデルを無効化
            viewer.style.display = 'none';
            viewer.removeAttribute('camera-controls');
            viewer.removeAttribute('auto-rotate');
            // WebGLレンダリングを停止（可能であれば）
            if (viewer.pause !== undefined) {
              viewer.pause = true;
            }
          }
        });
      });
    }
  }

  // Sync thumbnail column height with main image
  function syncThumbnailHeight() {
    if (window.innerWidth < 750) return; // Only for desktop/tablet
    
    const mainImage = document.querySelector('.sauna-product-container .box_l .product-single__media-wrapper:not(.hide)');
    const thumbnailColumn = document.querySelector('.sauna-thumbnails-column');
    
    if (mainImage && thumbnailColumn) {
      const height = mainImage.offsetHeight;
      thumbnailColumn.style.height = `${height}px`;
      thumbnailColumn.style.maxHeight = `${height}px`;
    }
  }

  // Initialize on DOM ready
  function initSaunaProduct() {
    // Check if we're on a sauna product page
    const saunaContainer = document.querySelector('.sauna-product-container');
    if (!saunaContainer) return;

    // Initialize vertical thumbnail slider (PC/タブレット用)
    const thumbnailSlider = document.querySelector('.sauna-thumbnails-column');
    if (thumbnailSlider && window.innerWidth >= 750) {
      new SaunaThumbnailSlider(thumbnailSlider);
    }

    // Initialize mobile horizontal thumbnail slider (スマホ用)
    if (window.innerWidth < 750) {
      // data-slider属性がなくても初期化できるように、複数のセレクターで探す
      const horizontalSliderContainer = document.querySelector('.thumbnails-wrapper[data-slider]')
        || document.querySelector('.thumbnails-wrapper')
        || document.querySelector('[data-thumbnail-slider]');
      
      if (horizontalSliderContainer) {
        new MobileThumbnailSlider(horizontalSliderContainer);
      }
    }

    // Initialize tabs
    const tabsContainer = document.querySelector('.sauna-tabs-container');
    if (tabsContainer) {
      new SaunaTabs(tabsContainer);
    }

    // Sync thumbnail height with main image
    syncThumbnailHeight();

    // Re-sync on window resize
    window.addEventListener('resize', syncThumbnailHeight);

    // Re-sync after images load
    const images = document.querySelectorAll('.sauna-product-container .box_l img');
    images.forEach(img => {
      if (img.complete) {
        syncThumbnailHeight();
      } else {
        img.addEventListener('load', syncThumbnailHeight);
      }
    });

  }

  const ESTIMATE_BTN_SELECTOR = '.js-estimate-btn-inline, #pseudo_click_estimate_btn_sp, #pseudo_click_estimate_btn_pc';

  function initEstimateButtons() {
    // 要素差し替え（セクション再レンダリング等）に強いイベント委譲方式
    if (document.body.dataset.estimateDelegationBound === '1') return;
    document.body.dataset.estimateDelegationBound = '1';
    document.addEventListener('click', function(e) {
      const btn = e.target.closest(ESTIMATE_BTN_SELECTOR);
      if (!btn) return;
      e.preventDefault();
      // 見積り・お問合せフォームは rfq-inquiry.js 側で開く。
    });
  }

  // ===== ギャラリー画像の先読み =====
  //
  // snippets/media.liquid は、メイン画像以外を `.hide`（display:none）の中に
  // `loading="lazy"` で置いている。ブラウザは display:none の lazy 画像を
  // **1枚もダウンロードしない**ので、サムネイルを押した瞬間に初めて取りに行く。
  // しかもそのURLは押した人しか叩かないためCDNのエッジがほぼ常に空で、
  // 初回クリックは 0.5〜4秒かかっていた（2026-09-22に本番で実測）。
  //
  // ここではページの読み込みが終わってから、隠れている画像のURLを裏で叩いて
  // HTTPキャッシュに載せておく。**DOMには一切触らない**ので、表示や
  // theme.js 側の切り替え処理には影響しない。押されたときは
  // キャッシュヒットになり、切り替えは数ミリ秒で終わる。
  function initGalleryPreload() {
    const imgs = Array.from(
      document.querySelectorAll('[data-product-single-media-wrapper] img.product-featured-media')
    );
    if (imgs.length < 2) return;

    // 通信を節約したい人・回線が細い人には先読みしない
    const conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (conn && (conn.saveData === true || /(^|-)2g$/.test(conn.effectiveType || ''))) return;

    const queue = imgs.filter(img => !(img.complete && img.naturalWidth > 0));
    if (queue.length === 0) return;

    const seen = new WeakSet();
    let running = 0;
    const MAX_PARALLEL = 2;

    // 裏の Image で同じ候補URLを取る。
    // ⚠️ srcset を使うので sizes も必ず同じ値を渡す。sizes はビューポート基準（vw）で
    //    書かれているため、DOMに挿していない Image でも実物と同じURLが選ばれる。
    //    ここがズレると別サイズを落としてしまい、先読みの意味が無くなる。
    function warm(img) {
      if (!img || seen.has(img)) return;
      seen.add(img);
      if (img.complete && img.naturalWidth > 0) return;

      running += 1;
      const ghost = new Image();
      if ('fetchPriority' in ghost) ghost.fetchPriority = 'low';
      ghost.decoding = 'async';

      let settled = false;
      const done = function() {
        if (settled) return;
        settled = true;
        running -= 1;
        pump();
      };
      ghost.addEventListener('load', done, { once: true });
      ghost.addEventListener('error', done, { once: true });
      // 1枚が詰まっても列が止まらないようにする
      setTimeout(done, 15000);

      const sizes = img.getAttribute('sizes');
      const srcset = img.getAttribute('srcset');
      if (sizes) ghost.sizes = sizes;
      if (srcset) ghost.srcset = srcset;
      ghost.src = img.currentSrc || img.src;
    }

    function pump() {
      while (running < MAX_PARALLEL) {
        const next = queue.shift();
        if (!next) return;
        if (seen.has(next)) continue;
        warm(next);
      }
    }

    // サムネイルが押されたら、その画像を列の先頭へ割り込ませる。
    // （先読みがまだそこまで進んでいなくても待たせない）
    document.addEventListener('click', function(e) {
      const thumb = e.target.closest('[data-thumbnail-id]');
      if (!thumb) return;
      const id = thumb.getAttribute('data-thumbnail-id');
      if (!id) return;
      const wrapper = document.querySelector(
        '[data-product-single-media-wrapper][data-media-id="' + id.replace(/"/g, '\\"') + '"]'
      );
      const img = wrapper && wrapper.querySelector('img.product-featured-media');
      if (img) warm(img);
    }, true);

    const start = function() {
      if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(pump, { timeout: 2000 });
      } else {
        setTimeout(pump, 1000);
      }
    };

    if (document.readyState === 'complete') {
      start();
    } else {
      window.addEventListener('load', start, { once: true });
    }
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initSaunaProduct();
      initEstimateButtons();
      initGalleryPreload();
    });
  } else {
    initSaunaProduct();
    initEstimateButtons();
    initGalleryPreload();
  }

  // Re-initialize on Shopify section re-render
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function() {
      initSaunaProduct();
      initEstimateButtons();
    });
  }
})();
